type FlutterChannel = {
    postMessage: (message: string) => void;
};

type HotdeskBridge = {
    setPrefill?: (payload: unknown) => void;
};

type BridgeWindow = Window & {
    js_to_flutter?: FlutterChannel;
    HotdeskBridge?: HotdeskBridge;
};

export function hasFlutterBridge(): boolean {
    if (typeof window === 'undefined') return false;
    return !!((window as BridgeWindow).js_to_flutter?.postMessage);
}

export function postToFlutter(messageType: string, message: unknown): void {
    if (typeof window === 'undefined') return;
    const bridge = (window as BridgeWindow).js_to_flutter;
    if (!bridge?.postMessage) return;
    bridge.postMessage(
        JSON.stringify({
            messageType,
            message:
                typeof message === 'string' ? message : JSON.stringify(message)
        })
    );
}

export function signalBridgeReady(): void {
    postToFlutter('bridgeReady', '1');
}

export function getHotdeskBridge(): HotdeskBridge | undefined {
    if (typeof window === 'undefined') return undefined;
    return (window as BridgeWindow).HotdeskBridge;
}

export function setHotdeskBridge(next: HotdeskBridge | undefined): void {
    if (typeof window === 'undefined') return;
    if (next) {
        (window as BridgeWindow).HotdeskBridge = next;
        return;
    }
    delete (window as BridgeWindow).HotdeskBridge;
}
